import styled from 'styled-components';

export const Section = styled.div`
  flex: 1;
  margin: 0 0 20px 0;
`;
